import React from 'react';
import { useSelector } from 'react-redux';
import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';

import RoutesSideBarBody from './RoutesSideBarBody';
import RoutesBarPaginate from './routeViewComponents/RoutesBarPaginate';

const RoutesView = () => {
    const dimensions = useSelector(liveTrackinglayoutSelector);
    
    return (
        <div style={dimensions.sidebar}>
            <div style={{ ...dimensions.routesListView, overflow: 'auto' }}>
                <RoutesSideBarBody />
            </div>
            <div style={dimensions.routesBarPaginate}>
                <RoutesBarPaginate />
            </div>
        </div>
    );
}

export default RoutesView; 